import './App.css';
import { Routes, Route, BrowserRouter } from "react-router-dom";
import Home from './Components/Home';
import About from './Components/About';
import Manu from './Components/Manu/Manu';
import Footer from './Components/Footer';
import Skills from './Components/Skills';
import Contact from './Components/Contact';
import Experience from './Components/Experience';
import Portfolio from './Components/Portfolio/Portfolio';


function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <Manu></Manu>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/#home" element={<Home />} />
          <Route path="/#about" element={<About />} />
          <Route path="/#skills" element={<Skills />} />
          <Route path="/#portfolio" element={<Portfolio />} />
          <Route path="/#experience" element={<Experience />} />
          <Route path="/#contact" element={<Contact />} />
        </Routes>

      </div>
      <Footer></Footer>
    </BrowserRouter>

  );
}

export default App;
